module.exports = __webpack_public_path__ + "static/covenant-house-logo-ec040dc603dff8c6b95500b909113eb4.png";